import { CLOSE_MODAL, OPEN_MODAL, SET_DATA, SET_POSITION, SET_SELECTED_INDEX } from "../actions/modalActions";
import type { ModalAction } from "../actions/modalActions";
import type { ModalState } from "../../types/redux";

const initialState: ModalState = {
    activeModal: null,
    position: null,
    data: { selectedIndex: 0 }
}

const modalsReducer = (state: ModalState = initialState, action: ModalAction): ModalState => {
    switch (action.type) {
        case OPEN_MODAL: 
            return {...state, activeModal: action.payload}
        case CLOSE_MODAL:
            return { ...state, activeModal: null, position: null }
        case SET_DATA: 
            return {...state, data: action.payload as ModalState['data']}
        case SET_POSITION: 
            return {...state, position: action.payload}
        case SET_SELECTED_INDEX:
            return {...state, data: {...state.data, selectedIndex: action.payload}}
        default:
            return state
    }
}

export default modalsReducer;
